module.exports = __webpack_public_path__ + "img/temperature.9c31baea.svg";